export default __webpack_public_path__ + "static/media/menu.df49a13a.svg";